import React from "react";
import { ModalProps, Image } from "react-bootstrap";

import "./WhyUseApkModal.scss";
import BottomModal from "../../../../components/BottomModal/BottomModal";
import GhostButton from "../../../../components/dashboard-page/GhostButton/GhostButton";
import ImageCloseIcon from "../../../../images/close-icon-purple.svg";
import FilledButton, {
  ButtonSizes,
} from "../../../../components/dashboard-page/FilledButton/FilledButton";

function WhyUseApkModal({ show, onHide }: ModalProps) {
  return (
    <BottomModal show={show} style={{ zIndex: 200 }}>
      <div className="why-use-apk-modal">
        <p className="d-flex justify-content-end mb-3 pe-2 pt-3">
          <GhostButton aria-label="close" onClick={onHide} className="d-inline">
            <Image src={ImageCloseIcon} width={30} height={30} />
          </GhostButton>{" "}
        </p>
        <h2>Here's why we use an APK</h2>
        <div className="explanation px-4 mb-4">
          <span className="mb-1 d-block">
            APKs are apps that are not on the Google Play Store.
          </span>
          <br />
          <span>
            Apps that allow gamers win real money from games of skill are
            heavily scrutinized by Google. Only gambling apps (games of chance)
            are allowed by Google. Apple App Store allows our app.
          </span>
        </div>
        <p className="px-3 pb-4">
          <FilledButton size={ButtonSizes.MD} fullwidth onClick={onHide}>
            Okay
          </FilledButton>
        </p>
      </div>
    </BottomModal>
  );
}

export default WhyUseApkModal;
